module.exports = __webpack_public_path__ + "static/media/sleep-deprivation-news.e25c2db4.jpg";